<template>
    <div>
        <!-- <figure class="image is-128x128">
            <img src="../assets/Tostatronic Shop-Logo.png">
        </figure> -->
        <section class="hero is-medium is-dark">
            <div class="hero-body bg-img">
                <div class="container">
                <h1 class="title">
                    Tostatronic Shop
                </h1>
                <h2 class="subtitle">
                    Componentes electrónicos e informáticos
                </h2>
                </div>
            </div>
        </section>

        <!-- <section class="section">
            <div class="container">
                <div class="columns is-multiline">
                    <div v-for="product in allProducts.slice(0,12)" v-bind:key="product.id" class="column is-3">
                        <ProductCard :name="product.title" :description="product.body" :idProducto="product.id" @addToCart="addToShoppingCart"/>
                    </div>
                </div>
            </div>
        </section> -->
        <b-loading :is-full-page="true" :can-cancel="false" :active.sync="isLoading"></b-loading>

        <ProductsList :productList="allProducts.slice(0,12)"/>

        <!-- <div>
            {{ allProducts.slice(0,2) }}
        </div> -->

        <section class="hero is-medium is-dark">
            <div class="hero-body bg-img-bottom">
                <div class="container">
                <h1 class="title">
                    Herramientas para tus proyectos
                </h1>
                </div>
            </div>
        </section>

        <ProductsList :productList="allProducts.slice(12,24)"/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import ProductsList from '@/components/ProductsList.vue'

export default {
    name: 'MainPage',
    components: {
        ProductsList
    },
    computed: mapGetters(["allProducts"]),
    data() {
        return {
            products: [],
            isLoading: true
        }
    },
    methods: {
        ...mapActions(["fetchProducts", "addItem"]),
    },
    created() {
        /* this.$axios.get(this.$URL + "posts").then(response => {
            this.products = response.data.slice(0,12)
        }) */
        this.fetchProducts()
        this.isLoading = false
    }
}
</script>

<style lang="css" scoped>
    
    .bg-img { 
        background-image: url(https://images.unsplash.com/photo-1517420704952-d9f39e95b43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80) ;
        background-position: center center;
        background-repeat:  no-repeat;
        background-attachment: fixed;
        background-size:  cover;
        background-color: #999;
    }

    .bg-img-bottom { 
        background-image: url(https://images.unsplash.com/photo-1563770660941-20978e870e26?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80) ;
        background-position: center center;
        background-repeat:  no-repeat;
        background-attachment: fixed;
        background-size:  cover;
        background-color: #999;
    }

</style>